import { Component, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { Message } from 'src/app/models/message';
import { Tematic } from 'src/app/models/obs/tematic';
import { Tier3 } from 'src/app/models/obs/tier3';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';

@Component({
  selector: 'app-global',
  templateUrl: './global.component.html',
  styleUrl: './global.component.scss'
})
export class GlobalComponent implements OnInit {

  msg: Message;
  tem: Tematic[];
  idTemSelected: string = null;
  t3: Tier3[];
  tematicT3: Tier3[];

  /* id Tendencias globales */
  idTier1: number = 11;

  color: string = "rgba(0,0,0,.125)";

  constructor(
    private temS: TematicService,
    private t3Service: Tier3Service
  ) { }

  ngOnInit() {
    this.gett34t1(this.idTier1);
    this.getTematics();
    this.drawHexas();
  }

  getTematics() {
    this.temS.getAll().subscribe({
      next: res => {
        this.tem = res['data'];
      },
      error: err => { this.msg = err; }
    });
  }

  gett34t1(id: number) {
    this.t3Service.getByIdTier1(id).subscribe({
      next: res => {
        this.t3 = res['data'];
      },
      error: err => { this.msg = err; }
    });
  }

  selectTematic(tem: string) {
    this.tem.forEach(t => {
      if (t.title.toLocaleUpperCase() == tem.toLocaleUpperCase()) {
        this.selectTrends(t.id);
        this.color = t.color
      }
    });
  }

  selectTrends(idTem: number) {
    this.tematicT3 = [];
    this.t3.forEach(o => {
      if (o.idtematic == idTem) {
        this.tematicT3.push(o);
      }
    });
  }

  drawHexas() {
    var self = this;
    var _s32 = (Math.sqrt(3) / 2);
    var A = 30;
    var xDiff = 100;
    var yDiff = 100;

    var pointData1 = [[214.12, 1.6], [231.3, 31.36], [248.48, 61.12], [231.3, 90.88], [214.12, 120.64], [179.75, 120.64], [145.38, 120.65], [128.2, 90.88], [111.02, 61.12], [128.2, 31.36], [145.38, 1.6], [179.75, 1.6], [214.12, 1.6]];
    var pointData2 = [[323.29, 64.63], [340.47, 94.39], [357.66, 124.15], [340.47, 153.92], [323.29, 183.68], [288.92, 183.68], [254.56, 183.68], [237.37, 153.92], [220.19, 124.15], [237.37, 94.39], [254.56, 64.63], [288.92, 64.63], [323.29, 64.63]];
    var pointData3 = [[323.29, 190.69], [340.47, 220.46], [357.66, 250.22], [340.47, 279.98], [323.29, 309.74], [288.92, 309.74], [254.56, 309.74], [237.37, 279.98], [220.19, 250.22], [237.37, 220.46], [254.56, 190.69], [288.92, 190.69], [323.29, 190.69]];
    var pointData4 = [[214.12, 253.72], [231.3, 283.49], [248.48, 313.25], [231.3, 343.01], [214.12, 372.77], [179.75, 372.77], [145.38, 372.77], [128.2, 343.01], [111.02, 313.25], [128.2, 283.49], [145.38, 253.73], [179.75, 253.73], [214.12, 253.72]];
    var pointData5 = [[104.94, 190.69], [122.12, 220.46], [139.31, 250.22], [122.12, 279.98], [104.94, 309.74], [70.57, 309.74], [36.21, 309.74], [19.02, 279.98], [1.84, 250.22], [19.02, 220.46], [36.21, 190.69], [70.57, 190.69], [104.94, 190.69]];
    var pointData6 = [[104.94, 64.63], [122.12, 94.39], [139.31, 124.15], [122.12, 153.92], [104.94, 183.68], [70.57, 183.68], [36.21, 183.68], [19.02, 153.92], [1.84, 124.15], [19.02, 94.39], [36.21, 64.63], [70.57, 64.63], [104.94, 64.63]];

    var svg = d3.select("#hexas-global") //create container
      .append("svg")
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 400 400");

    var textSocial = svg.append("text")
      .attr("x", 178)
      .attr("y", 70)
      .attr("id", "label-social")
      .style("font-size", "1.3rem")
      .style("font-family", "Calibri")
      .style("font-weight", "bold")
      .style("fill", "#FF5533")
      .style('text-anchor', 'middle')
      .text('Social')

    var pentaSocial = svg.selectAll("path.area") //draw elements
      .data([pointData1]).enter()
      .append("path")
      .style("fill", "#fff")
      .style("fill-opacity", 0)
      .style("stroke", "#FF5533")
      .style("stroke-dasharray", "40 5 5 2")
      .style("stroke-width", "2px")
      .attr("id", "social")
      .attr("d", d3.line())
      .on("click", click)
      .on("mouseover", mouseover)
      .on("mouseout", mouseout);


    var textAmb = svg.append("text")
      .attr("x", 282)
      .attr("y", 130)
      .attr("id", "label-amb")
      .style("font-size", "1.3rem")
      .style("font-family", "Calibri")
      .style("font-weight", "bold")
      .style("fill", "#059141")
      .style('text-anchor', 'middle')
      .text('Ambiental')

    var pentaAmb = svg.selectAll("path.area") //draw elements
      .data([pointData2]).enter().append("path")
      .style("fill", "#fff")
      .style("fill-opacity", 0)
      .style("stroke", "#059141")
      .style("stroke-dasharray", "40 5 5 2")
      .style("stroke-width", "2px")
      .attr("id", "ambiental")
      .attr("d", d3.line())
      .on("click", click)
      .on("mouseover", mouseover)
      .on("mouseout", mouseout);

    var textEc = svg.append("text")
      .attr("x", 285)
      .attr("y", 255)
      .attr("id", "label-ec")
      .style("font-size", "1.3rem")
      .style("font-family", "Calibri")
      .style("font-weight", "bold")
      .style("fill", "#686868")
      .style('text-anchor', 'middle')
      .text('Económica');

    var pentaEc = svg.selectAll("path.area") //draw elements
      .data([pointData3]).enter().append("path")
      .style("fill", "#fff")
      .style("fill-opacity", 0)
      .style("stroke", "#EFC514")
      .style("stroke-width", "2px")
      .style("stroke-dasharray", "40 5 5 2")
      .attr("id", "económica")
      .attr("d", d3.line())
      .on("click", click)
      .on("mouseover", mouseover)
      .on("mouseout", mouseout);

    var textTec = svg.append("text")
      .attr("x", 178)
      .attr("y", 320)
      .attr("id", "label-tec")
      .style("font-size", "1.3rem")
      .style("font-family", "Calibri")
      .style("font-weight", "bold")
      .style("fill", "#4e87c6")
      .style('text-anchor', 'middle')
      .text('Tecnológica');

    var pentaTec = svg.selectAll("path.area") //draw elements
      .data([pointData4]).enter().append("path")
      .style("fill", "#fff")
      .style("fill-opacity", 0)
      .style("stroke", "#4e87c6")
      .style("stroke-dasharray", "40 5 5 2")
      .style("stroke-width", "2px")
      .attr("id", "tecnológica")
      .attr("d", d3.line())
      .on("click", click)
      .on("mouseover", mouseover)
      .on("mouseout", mouseout);

    var textPol = svg.append("text")
      .attr("x", 65)
      .attr("y", 255)
      .attr("id", "label-pol")
      .style("font-size", "1.3rem")
      .style("font-family", "Calibri")
      .style("font-weight", "bold")
      .style("fill", "#9a20e2")
      .style('text-anchor', 'middle')
      .text('Política');

    var pentaPol = svg.selectAll("path.area") //draw elements
      .data([pointData5]).enter().append("path")
      .style("fill", "#fff")
      .style("fill-opacity", 0)
      .style("stroke", "#9a20e2")
      .style("stroke-dasharray", "40 5 5 2")
      .style("stroke-width", "2px")
      .attr("id", "política")
      .attr("d", d3.line())
      .on("click", click)
      .on("mouseover", mouseover)
      .on("mouseout", mouseout);

    var textEt = svg.append("text")
      .attr("x", 65)
      .attr("y", 140)
      .attr("id", "label-et")
      .style("font-size", "1rem")
      .style("font-family", "Calibri")
      .style("font-weight", "bold")
      .style("fill", "#83b7dd")
      .style('text-anchor', 'middle')
      .call(function (text) {
        text.append("tspan")
          .attr("x", 70)
          .attr("dy", "-0.6em")
          .text("Actitud, valores");
        text.append("tspan")
          .attr("x", 65)
          .attr("dy", "1.2em")
          .text("y ética");
      });

    var pentaEt = svg.selectAll("path.area") //draw elements
      .data([pointData6]).enter().append("path")
      .style("fill", "#fff")
      .style("fill-opacity", 0)
      .style("stroke", "#83b7dd")
      .style("stroke-dasharray", "40 5 5 2")
      .style("stroke-width", "2px")
      .attr("id", "ética")
      .attr("d", d3.line())
      .on("click", click)
      .on("mouseover", mouseover)
      .on("mouseout", mouseout);


    function click() {
      d3.selectAll("path")
        .transition()
        .duration(200)
        .style("stroke-width", "2px")
        .style("stroke-dasharray", "40 5 5 2");

      d3.select(this)
        .transition()
        .duration(200)
        .style("stroke-dasharray", "none")
        .style("stroke-width", "4px");

      self.selectTematic(this.id);
    }

    function mouseout() {
      d3.select(this)
        .attr("fill", "#000")
        .style("cursor", "normal");
    }

    function mouseover() {
      d3.select(this)
        .attr("fill", "pink")
        .style("cursor", "pointer");
    }

  }

}